import React, {Component} from 'react';
import { bool, func, object, shape } from 'prop-types';
import { Route, Redirect, Switch, NavLink } from 'react-router-dom';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';

import queryString from 'query-string';

import { isEmpty } from 'lodash';

import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import ProtectedRoute from '../components/ProtectedRoute';

import MyAccount from './MyAccount/MyAccount';
import Admin from './Admin/Admin';
import Architect from './Architect/Architect';
import AwsConfig from '../awsConfig';
import DevPortal from './DevPortal/DevPortal';
import Home from './Home/Home';
import IoTHub from './IoTHub/IoTHub';
import NavBar from '../components/NavBar';
import Banner from '../components/Banner';
import ProtectedNavLink from '../components/ProtectedNavLink';
import Rules from './Rules/Rules';
import ServiceManagement from './ServiceManagement/ServiceManagement';
import Subscriptions from './Subscriptions/Subscriptions';

import LoadProgressBar from '../components/LoadProgressBar';
import ProgressBar from '../components/ProgressBar';
import Tooltip from '@material-ui/core/Tooltip';

import {getUserRoleByCompany, setPageTitle} from '../helpers/auth';

import classes from './Esms.module.css';
import '@progress/kendo-theme-material/dist/all.css';

import { enqueueSnackbar, clearErrors } from '../actions/applicationMessageActions';
import * as ArchitectActions from '../actions/architectActions';
import * as BasAgentActions from '../actions/basAgentActions';
import * as ClientActions from '../actions/clientActions';
import * as CommunicationActions from '../actions/communicationActions';
import * as CoreActions from '../actions/coreActions';
import * as CurrentUserActions from '../actions/currentUserActions';
import * as CompanyInfoActions from '../actions/companyInfoActions';
import * as ErpAgentActions from '../actions/erpAgentActions';
import * as KnowiActions from '../actions/knowiActions';
import * as ProfileActions from '../actions/profileActions';
import * as UiActions from '../actions/uiActions';

const PATHS = ['/admin/communications/clients', '/admin/communications/status'];
const ERP_PATHS = ['/iothub/erpagents', '/iothub/erpagents/manage', '/iothub/erpagents/configure'];

class Esms extends Component {
    static defaultProps = {
        companyInfo:     {},
        enqueueSnackbar: () => {},
        firstTimeUser:   false
    }

    static propTypes = {
        companyInfo:     object,
        enqueueSnackbar: func,
        firstTimeUser:   bool,
        history:         shape({
            location: object.isRequired
        }).isRequired
    }

    state = {
        apiVersion:    null,
        clientVersion: null,
        menuOpen:      false,
        modalOpen:     false
    }

    componentDidMount() {
        if (!isEmpty(this.props.companyInfo) && !isEmpty(this.props.targetNavCompany) && this.props.companyInfo.companyId !== this.props.targetNavCompany.id) {
            this.handleCompanySelect(this.props.targetNavCompany.id);
        }

        // Make sure that the scroll bar is visible when the page is initially loaded.
        // When navigating to dashboard from here and back does not remove this class
        document.body.classList.remove('lockScroll');
    }

    async componentDidUpdate(prevProps, prevState) {
        const currentApp = this.props.history.location.pathname.split('/')[1];
        const { firstTimeUser } = this.props;

        if (currentApp !== prevProps.currentApp) {
            this.props.setCurrentApp(currentApp);

            setPageTitle(currentApp, this.props.companyInfo.companyName);
        }

        if (firstTimeUser && firstTimeUser !== prevProps.firstTimeUser) {
            this.props.history.push('/myaccount');
        }

        if (this.props.companyInfo !== prevProps.companyInfo) {
            const { setBootstrapping } = this.props;

            const currentApp = this.props.history.location.pathname.split('/')[1] || 'myaccount';

            this.props.setCurrentApp(currentApp);
            setBootstrapping(true);

            const queryValues = queryString.parse(this.props.history.location.search);

            try {
                const { companies } = this.props;
                this.props.setAllRoles(companies);

                if (companies.length > 0) {
                    let defaultCompany, targetCompany, msg;

                    if (queryValues.company) {
                        targetCompany = companies.find(company => {
                            return company.company.id === queryValues.company;
                        });
                    }

                    defaultCompany = companies.find(company => {
                        return company.company.id === this.props.currentUser.defaultCompany;
                    });

                    if (!defaultCompany && companies.length) {
                        defaultCompany = companies[0];
                        // eslint-disable-next-line no-console
                        console.log(`Could not find default company. Connecting to ${companies[0].company.name}`);
                    }

                    if (queryValues.company && defaultCompany && !targetCompany) {
                        msg = 'User has not been invited to this company. Default company selected.';

                        this.updatePathWithCompanyId(this.props.companyInfo);
                    } else if (defaultCompany) {
                        this.updatePathWithCompanyId(this.props.companyInfo);
                    } else {
                        this.props.history.push('/myaccount');
                        return;
                    }

                    if (msg) {
                        this.props.enqueueSnackbar(msg, 'warning');
                    }

                    await Promise.all([
                        this.props.fetchAllScopes(this.props.companyInfo.companyId ? this.props.companyInfo.companyId : defaultCompany.company.id),
                        this.props.fetchCurrentUserRole(this.props.companyInfo.companyId ? this.props.companyInfo.companyId : defaultCompany.company.id)
                    ].map(p => p.catch(err => err)));

                    this.setCurrentScopes(this.props.companyInfo.companyId);

                    setPageTitle(currentApp, this.props.companyInfo.companyName);

                    setBootstrapping(false);
                } else {
                    this.props.history.push('/myaccount');

                    setBootstrapping(false);
                }
            } catch (error) {
                setBootstrapping(false);
                this.props.enqueueSnackbar('Application failed to bootstrap. Refresh your browser.', 'error');
            }
        }
    }

    addScrollLock = () => {
        document.body.classList.add('lockScroll');
    }

    removeScrollLock = () => {
        document.body.classList.remove('lockScroll');
    }

    updatePathWithCompanyId = (companyInfo = {}) => {
        if (isEmpty(companyInfo)) {
            return;
        }

        const { pathname } = this.props.history.location;
        const { companyId } = companyInfo;

        const queryValues = queryString.parse(this.props.history.location.search);
        queryValues.company = companyId;

        const queryValuesString = queryString.stringify(queryValues);

        this.props.history.push(`${pathname}?${queryValuesString}`);
    }

    setCurrentScopes = async companyId => {
        if (!companyId) {
            return;
        }

        const {allRoles, companies} = this.props;

        let userRole = getUserRoleByCompany(allRoles, companyId);
        let currentScopes;

        if (userRole) {
            currentScopes = userRole.scopes;
        } else {
            this.props.setAllRoles(companies);

            userRole = getUserRoleByCompany(allRoles, companyId);
            currentScopes = userRole.scopes;
        }

        this.props.setCurrentScopes(currentScopes);
    }

    closeSideNav = () => {
        this.removeScrollLock();

        this.setState({ menuOpen: false });
    }

    renderNavBar = () => {
        const { currentApp } = this.props;

        const { pathname } = this.props.history.location;

        switch (currentApp) {
            case 'admin':
                return (
                    <React.Fragment>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Admin</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <NavLink
                                aria-label="Admin"
                                exact
                                to={{
                                    pathname: '/admin',
                                    search:   this.props.location.search
                                }}
                                activeClassName="activeNavLink"
                            >
                                <img src="/assets/images/adminIconOutline.svg" alt="" />
                            </NavLink>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Users</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Users"
                                    exact
                                    permissions="adminFull"
                                    to={{
                                        pathname: '/admin/users',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/UsersOutline.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Roles</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Roles"
                                    exact
                                    permissions="adminFull"
                                    to={{
                                        pathname: '/admin/roles',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/RolesOutline.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        {
                            process.env.advancedCommEnabled &&
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <span className={classes.tooltip}>Advanced Communications</span>
                                    </React.Fragment>
                                }
                                placement="right"
                            >
                                <div>
                                    <ProtectedNavLink
                                        activeClassName="activeNavLink"
                                        aria-label="Communications"
                                        exact
                                        permissions="adminFull"
                                        isActive={() => PATHS.includes(pathname)}
                                        to={{
                                            pathname: '/admin/communications/clients',
                                            search:   this.props.location.search
                                        }}
                                    >
                                        <img src="/assets/images/advancedComms-outline.svg" alt="" />
                                    </ProtectedNavLink>
                                </div>
                            </Tooltip>
                        }
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Scoring</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Scoring"
                                    exact
                                    permissions="adminFull"
                                    to={{
                                        pathname: '/admin/scoring',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/scoringWhiteIcon.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                    </React.Fragment>
                );
            case 'devportal':
                return (
                    <Tooltip
                        title={
                            <React.Fragment>
                                <span className={classes.tooltip}>API Docs</span>
                            </React.Fragment>
                        }
                        placement="right"
                    >
                        <NavLink
                            aria-label="Documentation"
                            exact
                            to={{
                                pathname: '/devportal/docs',
                                search:   this.props.location.search
                            }}
                            activeClassName="activeNavLink"
                        >
                            <img src="/assets/images/DocsOutline.svg" alt="" />
                        </NavLink>
                    </Tooltip>
                );
            case 'iothub':
                return (
                    <React.Fragment>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>IoT Hub</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <NavLink
                                aria-label="IOT Hub"
                                exact
                                to={{
                                    pathname: '/iothub',
                                    search:   this.props.location.search
                                }}
                                activeClassName="activeNavLink"
                            >
                                <img src="/assets/images/iotHubHomeLeftNav.svg" alt="" />
                            </NavLink>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>BAS Agents</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="BAS Agents"
                                    exact
                                    permissions="iothubRead"
                                    to={{
                                        pathname: '/iothub/basagents',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/basAgentLeftNav.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        {
                            process.env.erpAgentEnabled &&
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <span className={classes.tooltip}>FSM Integrations</span>
                                    </React.Fragment>
                                }
                                placement="right"
                            >
                                <div>
                                    <ProtectedNavLink
                                        activeClassName="activeNavLink"
                                        aria-label="ERP Agents"
                                        exact
                                        permissions="iothubRead"
                                        isActive={() => ERP_PATHS.includes(pathname)}
                                        to={{
                                            pathname: '/iothub/erpagents',
                                            search:   this.props.location.search
                                        }}
                                    >
                                        <img src="/assets/images/erpAgentLeftNav.svg" alt="" />
                                    </ProtectedNavLink>
                                </div>
                            </Tooltip>
                        }
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Profiles</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Profiles"
                                    exact
                                    permissions="iothubRead"
                                    to={{
                                        pathname: '/iothub/profiles',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/profilesLeftNav.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Downloads</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Downloads"
                                    exact
                                    permissions="iothubRead"
                                    to={{
                                        pathname: '/iothub/downloads',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/downloadsLeftNav.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                    </React.Fragment>
                );
            case 'architect':
                return (
                    <React.Fragment>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Architect</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Architect"
                                    exact
                                    permissions="architectRead"
                                    to={{
                                        pathname: '/architect',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/bluePrintsLeftNav.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Conversion</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Conversion"
                                    exact
                                    permissions="architectRead"
                                    to={{
                                        pathname: '/architect/conversion',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/conversionIcon.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        {
                            process.env.technicianEnabled &&
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <span className={classes.tooltip}>Technician</span>
                                    </React.Fragment>
                                }
                                placement="right"
                            >
                                <div>
                                    <ProtectedNavLink
                                        activeClassName="activeNavLink"
                                        aria-label="Technician"
                                        exact
                                        permissions="architectRead"
                                        to={{
                                            pathname: '/architect/technician',
                                            search:   this.props.location.search
                                        }}
                                    >
                                        <img src="/assets/images/hardHatBlackWhiteOutline.svg" alt="" />
                                    </ProtectedNavLink>
                                </div>
                            </Tooltip>
                        }
                        {
                            process.env.erpAgentEnabled &&
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <span className={classes.tooltip}>Service Call Statuses</span>
                                    </React.Fragment>
                                }
                                placement="right"
                            >
                                <div>
                                    <ProtectedNavLink
                                        activeClassName="activeNavLink"
                                        aria-label="Service Call Statuses"
                                        exact
                                        permissions="architectRead"
                                        to={{
                                            pathname: '/architect/servicecallstatuses',
                                            search:   this.props.location.search
                                        }}
                                    >
                                        <img src="/assets/images/advisorServiceLeftNavIcon.svg" alt="" />
                                    </ProtectedNavLink>
                                </div>
                            </Tooltip>
                        }
                    </React.Fragment>
                );
            case 'rules':
                return (
                    <Tooltip
                        title={
                            <React.Fragment>
                                <span className={classes.tooltip}>Rules</span>
                            </React.Fragment>
                        }
                        placement="right"
                    >
                        <div>
                            <ProtectedNavLink
                                activeClassName="activeNavLink"
                                aria-label="Rules"
                                exact
                                permissions="rulesRead"
                                to={{
                                    pathname: '/rules',
                                    search:   this.props.location.search
                                }}
                            >
                                <img src="/assets/images/rulesHomeLeftNav.svg" alt="" />
                            </ProtectedNavLink>
                        </div>
                    </Tooltip>
                );
            case 'subscriptions':
                return (
                    <React.Fragment>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>User Subscriptions</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Subscriptions"
                                    exact
                                    permissions="subscriptionRead"
                                    to={{
                                        pathname: '/subscriptions',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/UserSubscriptionsIconOutline.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Contact Subscriptions</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Subscriptions"
                                    exact
                                    permissions="subscriptionFull"
                                    to={{
                                        pathname: '/subscriptions/contact',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/ContactSubscriptionsIconOutline.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                    </React.Fragment>
                );
            case 'servicemanagement':
                return (
                    <React.Fragment>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Management</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Management"
                                    exact
                                    permissions="serviceManagementRead"
                                    to={{
                                        pathname: '/servicemanagement',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/serviceManualIconWhite.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <span className={classes.tooltip}>Settings</span>
                                </React.Fragment>
                            }
                            placement="right"
                        >
                            <div>
                                <ProtectedNavLink
                                    activeClassName="activeNavLink"
                                    aria-label="Settings"
                                    exact
                                    permissions="serviceManagementFull"
                                    to={{
                                        pathname: '/servicemanagement/settings',
                                        search:   this.props.location.search
                                    }}
                                >
                                    <img src="/assets/images/adminIconOutline.svg" alt="" />
                                </ProtectedNavLink>
                            </div>
                        </Tooltip>
                    </React.Fragment>
                );
            default:
                break;
        }
    }

    handleCompanySelect = async id => {
        const { companies } = this.props;

        try {
            const currentCompany = companies.find(company => {
                return company.company.id === id;
            });

            if (currentCompany) {
                await this.props.fetchCompanyInfo(currentCompany);

                const {companyInfo, currentApp} = this.props;

                this.closeSideNav();

                sessionStorage.setItem('companyId', companyInfo.companyId);

                this.props.setAllRoles(companies);

                this.props.fetchAllScopes(companyInfo.companyId);
                this.props.fetchCurrentUserRole(companyInfo.companyId);

                this.props.setClient(null);

                this.setCurrentScopes(companyInfo.companyId);

                if (!companyInfo.enabled) {
                    this.updatePathWithCompanyId(companyInfo);
                    setPageTitle(currentApp, companyInfo.companyName);

                    this.props.enqueueSnackbar('This Company is disabled, please contact Key2Act Support for more information.', 'warning');

                    return;
                }

                await this.props.fetchInitialClients(companyInfo.companyId);

                this.props.fetchBasAgents(companyInfo.companyId);
                this.props.fetchErpAgents(companyInfo.companyId);
                this.props.fetchProfiles(companyInfo.companyId);
                this.props.setErpAgent(null);

                this.updatePathWithCompanyId(companyInfo);
                setPageTitle(currentApp, companyInfo.companyName);

                this.props.enqueueSnackbar('Company changed successfully.', 'success');
            } else {
                this.props.enqueueSnackbar('Company was not changed.', 'error');
            }

        } catch (error) {
            this.props.enqueueSnackbar('Company was not changed.', 'error');
        }
    }

    handleMenuToggle = toggleState => {
        const menuOpen = this.state.menuOpen;

        if (!menuOpen) {
            this.addScrollLock();
        } else {
            this.removeScrollLock();
        }

        this.setState({menuOpen: toggleState});
    }

    handleSidebarClickAway = () => {
        this.closeSideNav();
    }

    handleAppToggle = app => {
        const {companyInfo} = this.props;

        this.closeSideNav();

        this.updatePathWithCompanyId(companyInfo);

        this.props.setCurrentApp(app);
    }

    handleHelp = () => {
        window.open(AwsConfig.key2act.helpUrl, '_blank');
    }

    handleCloseModal = () => {
        this.setState(state => ({modalOpen: false}));
    }

    handleSignOut = () => {
        this.props.history.push('/');

        this.props.signOut();
    }

    handleStatusPage = () => {
        window.open('https://k2a-bob.statuspage.io/#', '_blank');
    }

    render() {
        const {companyInfo, progressBarLoading, loadProgressBarLoading, settings} = this.props;
        const showBanner = companyInfo.billingStatus === 1 || companyInfo.billingStatus === 3;

        return (
            <div className={classes.Esms}>
                <Header
                    toggle={this.handleMenuToggle}
                    app={this.props.currentApp}
                    signOut={this.handleSignOut}
                    help={this.handleHelp}
                    status={this.handleStatusPage}
                    userName={this.props.currentUser.userName}
                    isBootStrapping={this.props.isBootStrapping}
                />
                {
                    showBanner &&
                    <Banner
                        companyInfo={companyInfo}
                    />
                }
                <Sidebar
                    toggle={this.handleMenuToggle}
                    toggleState={this.state.menuOpen}
                    appToggle={this.handleAppToggle}
                    clearErrors={this.props.clearErrors}
                    app={this.props.currentApp}
                    companies={this.props.companies}
                    companyInfo={this.props.companyInfo}
                    companySelect={this.handleCompanySelect}
                    handleClickAway={this.handleSidebarClickAway}
                    history={this.props.history}
                    isEnabled={companyInfo.enabled}
                />
                <div className={classes.contentContainer}>
                    <NavBar>{this.renderNavBar()}</NavBar>
                    <ProgressBar className={classes.progressBarOverride} hidden={!progressBarLoading} />
                    <LoadProgressBar
                        hidden={!loadProgressBarLoading}
                        maxValue={settings.maxValue}
                        currentValue={settings.currentValue}
                        label={settings.label}
                    />
                    <Switch>
                        <Route
                            path="/myaccount"
                            render={(routeProps) => (
                                <MyAccount
                                    {...routeProps}
                                    signOut={this.props.signOut}
                                />
                            )}
                        />
                        <Route
                            path="/admin"
                            render={(routeProps) => (
                                <Admin {...routeProps} />
                            )}
                        />
                        <ProtectedRoute
                            component={Home}
                            path="/home"
                            permissions="homeRead"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={IoTHub}
                            path="/iothub"
                            permissions="iothubRead"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={Architect}
                            path="/architect"
                            permissions="architectRead"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={DevPortal}
                            path="/devportal"
                            permissions="default"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={Rules}
                            path="/rules"
                            permissions="rulesRead"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={ServiceManagement}
                            path="/servicemanagement"
                            permissions="serviceManagementRead"
                            isEnabled={companyInfo.enabled}
                        />
                        <ProtectedRoute
                            component={Subscriptions}
                            path="/subscriptions"
                            permissions="subscriptionRead"
                            isEnabled={companyInfo.enabled}
                        />
                        {
                            process.env.executiveSummaryEnabled ?
                                <Redirect from="/" to="/v2/dashboard/executivesummary" />
                                :
                                process.env.isBobLandingEnabled ?
                                    <Redirect from="/" to="/v2/dashboard/company" />
                                    :
                                    <Redirect from="/" to="/home" />
                        }
                    </Switch>
                </div>
                {this.state.menuOpen ? (<div className={classes.screen} />) : null}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    allRoles:               state.core.allRoles,
    allScopes:              state.core.allScopes,
    companies:              state.core.companies,
    companyInfo:            state.companyInfo,
    currentApp:             state.core.currentApp,
    currentScopes:          state.core.currentScopes,
    currentUser:            state.currentUser,
    integrationTypes:       state.core.integrationTypes,
    isBootStrapping:        state.core.isBootStrapping,
    loadProgressBarLoading: state.ui.loadProgressBarLoading,
    progressBarLoading:     state.core.progressBarLoading,
    settings:               state.ui.settings,
    targetNavCompany:       state.bob.targetNavCompany,
});

const mapDispatchToProps = {
    enqueueSnackbar,
    clearErrors,
    ...ArchitectActions,
    ...BasAgentActions,
    ...ClientActions,
    ...CommunicationActions,
    ...CoreActions,
    ...CurrentUserActions,
    ...CompanyInfoActions,
    ...ErpAgentActions,
    ...KnowiActions,
    ...ProfileActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Esms));
